import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils/api'
import { getApiErrorMessage } from '@/utils/error'

import { GET_CHECKLISTS_BASE_QUERY_KEY } from './get-checklists'

interface BulkDeleteChecklistsRequest {
  checklistIds: number[]
  buildingId: number
}

interface BulkDeleteChecklistsResponse {
  completed: number[]
  failed: {
    id: number
    status: number
    message: string
  }[]
}

export const bulkDeleteChecklists = async (data: BulkDeleteChecklistsRequest) => {
  const response = await authAPI.post<BulkDeleteChecklistsResponse>(
    `/checklist-unified/${data.buildingId}/bulk-delete`,
    {
      ids: data.checklistIds,
    },
  )
  return response.data
}

export const useBulkDeleteChecklists = () => {
  return useMutation({
    mutationFn: bulkDeleteChecklists,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async (response) => {
      await resetQueries([GET_CHECKLISTS_BASE_QUERY_KEY])

      if (response.failed.length > 0) {
        toastFactory.error(
          `${response.completed.length} checklists deleted successfully, ${response.failed.length} checklists failed to delete`,
        )
        return
      }

      toastFactory.success('Selected checklists deleted successfully')
    },
  })
}
